// エラーコードに対する紐付けデータ
type ErrorData = {
  // コード
  code: string
  // リソースキー
  key: string
}

// エラーコード紐付け定義一覧
const ErrorDataKey: Array<ErrorData> = [
  // ダウンロード失敗
  {
    code: 'download',
    key: 'error.fail.download',
  },
]

/**
 * 指定したコードに対したエラーコードに対する紐付けデータを取得する
 * @param code 検索コード
 * @returns 紐付けデータ
 */
const getFailMsgkey = (code: string) => ErrorDataKey.find((p) => p.code === code)

export { getFailMsgkey }
